// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__lOLnl","tooltiptext":"tooltip_tooltiptext__b4Phh","tooltiptextBottom":"tooltip_tooltiptextBottom__AZG87"};